(function($, Drupal, once) {

  Drupal.behaviors.retain_features_accordion = {
    attach: function (context, settings) {

      $('.features-accordion').each(function(){
        const accordion = $(this);
        const items = accordion.find('.features-accordion-item');
        const screenshots = accordion.find('.features-accordion-item-screenshot');

        // Make the first item and screenshot active
        items.first().addClass('active');
        screenshots.first().addClass('active');

        accordion.on('click', '.accordion-toggle', function(e) {
          e.preventDefault();

          const item = $(this).closest('.features-accordion-item');
          const index = item.index();

          items.removeClass('active');
          screenshots.removeClass('active');

          item.addClass('active');
          screenshots.eq(index).addClass('active');
        });
      });

    }
  }

})(jQuery, Drupal, once)




